import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import api from "../../api/api";
import { clearAuthToken, setAuthToken } from "../../api/authToken";
import { clearAnswerBookletPdf } from "./AnswerBookletPdfSlice";
import { clearAnswerHintPdf } from "./AnswerHintPdfSlice";
import { clearQuestionPaperPdf } from "./QuestionPaperPdfSlice";

// export const loginUser = createAsyncThunk(
// 	"auth/login",
// 	async (credentials, { rejectWithValue }) => {
// 		try {
// 			const response = await api.post("/Account/authenticate", credentials);
// 			const userData = response.data?.data || {};
// 			const token = userData.jwToken;
// 			setAuthToken(token);

// 			let username =
// 				userData.userName ||
// 				credentials?.username ||
// 				null;

// // 			const lastLogin = userData.lastLoggedIn? (() => {
// //       const date = new Date(userData.lastLoggedIn);
// //       const day = String(date.getDate()).padStart(2, "0");
// //       const month = String(date.toLocaleString("en-IN", { month: "short" }));
// //       const year = date.getFullYear();

// //       const hours = String(date.getHours()).padStart(2, "0");
// //       const minutes = String(date.getMinutes()).padStart(2, "0");
// //       const seconds = String(date.getSeconds()).padStart(2, "0");

// //       return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
// //     })()
// //   : null;
// const lastLogin = userData.lastLoggedIn
//   ? (() => {
//       const formatter = new Intl.DateTimeFormat("en-IN", {
//         timeZone: "Asia/Kolkata",
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: false,
//       });

//       const parts = formatter.formatToParts(
//         new Date(
//           userData.lastLoggedIn.endsWith("Z")
//             ? userData.lastLoggedIn
//             : `${userData.lastLoggedIn}Z`
//         )
//       );

//       const get = (type) => parts.find((p) => p.type === type)?.value;

//       return `${get("day")}/${get("month")}/${get("year")} ${get("hour")}:${get("minute")}:${get("second")}`;
//     })()
//   : null;

// 			if (!username && token) {
// 				const decoded = jwtDecode(token);
// 				username =
// 					decoded.userName || null;
// 			}

// 			toast.success("Log-in successful!");
// 			return { username, lastLogin };
// 		} catch (error) {
			
// 			clearAuthToken();
// 			// toast.error(error.response?.data?.Message || "Login Failed");
// 			// return rejectWithValue(error.response?.data || "Login failed");
// 			let errorMessage;

//     if (!error.response) {
//         // No response received (Internet down, DNS issue, server unreachable, CORS, etc.)
//         errorMessage = navigator.onLine
//             ? "Unable to connect to the server. Please try again."
//             : "No internet connection. Please check your network.";
//     } else {
//         errorMessage = error.response.data?.Message || "Login Failed";
//     }

//     toast.error(errorMessage);
// 	return rejectWithValue(errorMessage);
// 		}
// 	},
// );
export const loginUser = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const [loginResponse, ipResponse] = await Promise.all([
        api.post("/Account/authenticate", credentials),
        api.get("/Account/ip4-address"),
      ]);

      const userData = loginResponse.data?.data || {};
      const token = userData.jwToken;

      setAuthToken(token);

      const ipAddress = ipResponse.data;

      let username =
        userData.userName ||
        credentials?.username ||
        null;

      const lastLogin = userData.lastLoggedIn
        ? (() => {
            const formatter = new Intl.DateTimeFormat("en-IN", {
              timeZone: "Asia/Kolkata",
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            });

            const parts = formatter.formatToParts(
              new Date(userData.lastLoggedIn
                  // : `${userData.lastLoggedIn}Z`
              )
            );

            const get = (type) =>
              parts.find((p) => p.type === type)?.value;

            return `${get("day")}/${get("month")}/${get("year")} ${get(
              "hour"
            )}:${get("minute")}:${get("second")}`;
          })()
        : null;

      toast.success("Log-in successful!");

      return {
        username,
        lastLogin,
        ipAddress,
      };
    } catch (error) {
      clearAuthToken();

      let errorMessage;

      if (!error.response) {
        errorMessage = navigator.onLine
          ? "Unable to connect to the server. Please try again."
          : "No internet connection. Please check your network.";
      } else {
        errorMessage = error.response.data?.Message || "Login Failed";
      }

      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const logoutUser = createAsyncThunk(
	"auth/logout",
	async (_, { dispatch }) => {
		clearAuthToken();
		dispatch(clearAnswerBookletPdf());
		dispatch(clearAnswerHintPdf());
		dispatch(clearQuestionPaperPdf());
		dispatch(logout());
	},
);

const authSlice = createSlice({
	name: "auth",
	initialState: {
		username: null,
		 ipAddress: "",
		isAuthenticated: false,
		loading: false,
		error: null,
		lastLogin: null,
	},
	reducers: {
		logout(state) {
			state.username = null;
			state.isAuthenticated = false;
			state.error = null;
			state.loading = false;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(loginUser.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(loginUser.fulfilled, (state, action) => {
				state.loading = false;
				 if (!action.payload) return;
				state.username = action.payload.username;
				state.isAuthenticated = true;
				state.lastLogin = action.payload.lastLogin;
				  state.ipAddress = action.payload.ipAddress;
			})
			.addCase(loginUser.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})
			.addCase(logoutUser.pending, (state) => {
				state.loading = true;
			})
			.addCase(logoutUser.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(logoutUser.rejected, (state) => {
				state.loading = false;
				state.lastLogin = null;
			});
	},
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
